import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { toast } from "../hooks/use-toast";
import { Send } from "lucide-react";

const EnquiryModal = ({ open, onOpenChange }) => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", unit: "3 BHK" });
  const [loading, setLoading] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast({ title: "Name and phone are required." }); return; }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      onOpenChange(false);
      toast({ title: "Enquiry received!", description: "Our sales team will connect with you shortly." });
      try {
        const list = JSON.parse(localStorage.getItem("eternia_enquiries") || "[]");
        list.push({ ...form, ts: new Date().toISOString(), source: "modal" });
        localStorage.setItem("eternia_enquiries", JSON.stringify(list));
      } catch (e) { /* noop */ }
      setForm({ name: "", phone: "", email: "", unit: "3 BHK" });
    }, 700);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[460px] bg-[#f8f2e8] border border-[#c26a4a]/40">
        <DialogHeader>
          <DialogTitle className="h-title text-[26px]">Enquire About Eternia</DialogTitle>
          <DialogDescription className="text-[#6b6a63]">Share your details — our sales team will reach out with the inaugural offer.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 pt-2">
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Full Name*" className="w-full bg-white border border-[#c26a4a]/30 rounded-lg px-4 py-3 outline-none focus:border-[#c26a4a] transition" />
          <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Phone Number*" className="w-full bg-white border border-[#c26a4a]/30 rounded-lg px-4 py-3 outline-none focus:border-[#c26a4a] transition" />
          <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className="w-full bg-white border border-[#c26a4a]/30 rounded-lg px-4 py-3 outline-none focus:border-[#c26a4a] transition" />
          <select value={form.unit} onChange={(e) => setForm({ ...form, unit: e.target.value })} className="w-full bg-white border border-[#c26a4a]/30 rounded-lg px-4 py-3 outline-none focus:border-[#c26a4a] transition">
            <option>3 BHK</option>
            <option>3 BHK + Study</option>
            <option>4 BHK + Study</option>
          </select>
          <button disabled={loading} type="submit" className="btn-gold w-full justify-center">{loading ? "SUBMITTING..." : "SUBMIT ENQUIRY"} <Send size={14} /></button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EnquiryModal;
